'use client';

import React, { useMemo } from 'react';
import { Text } from '../Text';
import { buildEscapedRegex, createHighlighted, createUnhighlighted } from './utils';
export const PredictedHeader = ({
  'data-testid': dataTestId,
  queryString,
  fullString
}) => {
  const locations = useMemo(() => Array.from(fullString.matchAll(buildEscapedRegex(queryString))).map(a => a.index), [fullString, queryString]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, queryString && locations.length ? locations.map((locationOfQueryString, index) => /*#__PURE__*/React.createElement("span", {
    key: index,
    "data-testid": dataTestId
  }, createUnhighlighted(fullString, locations[index - 1] + queryString.length, locationOfQueryString), createHighlighted(fullString, locationOfQueryString, queryString.length), index === locations.length - 1 && createUnhighlighted(fullString, locationOfQueryString + queryString.length, fullString.length))) : /*#__PURE__*/React.createElement(Text, {
    size: 2
  }, fullString));
};